import { FilterFields, useLazyFetchProductsJsonQuery } from "../../../../Domains/Products/api/productJsonApi.ts";
import { Controller, ControllerProps } from "react-hook-form";
import FormFieldTwoColumns from "../Forms/Layouts/FormFieldTwoColumns.tsx";
import { RenderOption } from "../../views/OptionGroups/Tabs/AutocompleteProductRenderOption.tsx";
import React from "react";
import { AutocompleteItemableProps, AutocompleteProduct } from "@jamezz/react-components";

export function FormAutocomplete({
  tKey,
  tDefault,
  name,
  autcompleteProps,
  value,
  onChange,
}: {
  tKey: string;
  tDefault: string;
  name: string;
  autcompleteProps: Partial<AutocompleteItemableProps<any, true, false, FilterFields>>;
  value: (
    field: Parameters<ControllerProps["render"]>[0]["field"]
  ) => AutocompleteItemableProps<any, true, false, FilterFields>["value"];
  onChange: (
    field: Parameters<ControllerProps["render"]>[0]["field"]
  ) => AutocompleteItemableProps<any, true, false, FilterFields>["onChange"];
}) {
  const { ...otherProps } = autcompleteProps;

  return (
    <FormFieldTwoColumns tKey={tKey} tDefault={tDefault}>
      <Controller
        name={name}
        render={({ field }) => {
          let parsedValue: Array<any>;
          try {
            parsedValue = value?.(field) ?? JSON.parse(field.value ?? "[]");
          } catch (e) {
            parsedValue = [];
          }

          return (
            <AutocompleteProduct
              inputFieldProps={{ sx: { minWidth: 400 } }}
              multiple={true}
              defaultFilters={{
                vestiging_id: { field: "vestiging_id", operator: "=", value: autcompleteProps.menuSalesareaId },
                is_option: { field: "is_option", value: false },
              }}
              menuSalesareaId={autcompleteProps.menuSalesareaId}
              fetchQuery={useLazyFetchProductsJsonQuery}
              renderOption={(props, option) => <RenderOption option={option} />}
              {...otherProps}
              value={parsedValue}
              onChange={
                onChange?.(field) ??
                ((value) => {
                  field.onChange(JSON.stringify((value ?? []).map((item) => item.id)));
                })
              }
            />
          );
        }}
      />
    </FormFieldTwoColumns>
  );
}
